import type { LiveSheetSpell, LiveSlotBreakdown } from "../../types/generated/live";
import { interpolate, type Labels } from "./labels";

// The spells a card lists: what is memorized, and every exclusive spell (a circle-less one is cast from the list, not memorized).
export function listedSpells<T extends Pick<LiveSheetSpell, "circle" | "times_memorized">>(spells: T[]): T[] {
	return spells.filter((spell) => spell.circle == null || spell.times_memorized > 0);
}

// "alcance · duração · JP"; a spell with no saving throw ("nenhuma") leaves it out.
export function spellMeta(spell: Pick<LiveSheetSpell, "range" | "duration" | "jp">): string {
	const jp = spell.jp?.toLowerCase() === "nenhuma" ? null : spell.jp;
	return [spell.range, spell.duration, jp].filter(Boolean).join(" · ");
}

// Spent once every use box is filled; a spell with no box is never spent.
export function allSpent(uses: string[], spent: Set<string>): boolean {
	return uses.length > 0 && uses.every((key) => spent.has(key));
}

// "Magias por Dia: 2 de 3 memorizadas": what the circle's spells memorize of the slots it has.
export function perDayLabel(slot: LiveSlotBreakdown, spells: Pick<LiveSheetSpell, "times_memorized">[], labels: Labels): string {
	const memorized = spells.reduce((sum, spell) => sum + spell.times_memorized, 0);
	return interpolate(labels.spells.per_day, { memorized, total: slot.breakdown.total });
}

// Every circle with slots or spells, the circle-less spells first, so a caster with none chosen still shows its capacity.
export function slotCircles(slots: LiveSlotBreakdown[], spellCircles: (number | null)[]): (number | null)[] {
	return [...new Set([...slots.map((slot) => slot.circle), ...spellCircles])].sort((a, b) => (a ?? 0) - (b ?? 0));
}
